import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const CREW_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_b3b-bracket-book/artifacts/w71slqd3_016.webp";

export default function CommunityBanner() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="community-banner"
      className="relative overflow-hidden border-y border-purple-900/40"
    >
      <motion.img
        src={CREW_IMG}
        alt="The 3x3 Street Crown League crew on the court"
        style={{ y }}
        className="h-[46vh] w-full scale-125 object-cover object-center sm:h-[60vh]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#08040F] via-transparent to-[#08040F]/70" />
      <div className="absolute inset-x-0 bottom-0 px-4 pb-6 sm:px-8 sm:pb-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto max-w-7xl"
        >
          <p className="font-mono-b3b text-[10px] uppercase tracking-[0.3em] text-yellow-400">
            The crew, last crown
          </p>
          <p className="mt-1 font-display text-3xl uppercase leading-none tracking-wide text-white sm:text-5xl">
            This could be you but <span className="text-yellow-400">you playin!</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
